"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _atom = require("atom");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _OptionTypes = require("UIComponents/types/OptionTypes");

var _react = _interopRequireWildcard(require("react"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _ReferenceResolverAllType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverAllType"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _utils = require("reference-resolvers/utils");

var _omit = _interopRequireDefault(require("transmute/omit"));

var propTypes = {
  filter: _react.PropTypes.func,
  onChange: _react.PropTypes.func.isRequired,
  optionFormatter: _react.PropTypes.func,
  options: _react.PropTypes.arrayOf(_OptionTypes.OptionType.isRequired),
  readOnly: _react.PropTypes.bool,
  resolver: _ReferenceResolverAllType.default.isRequired,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired)]),
  multi: _react.PropTypes.bool
};
var defaultProps = {
  options: []
};
var initialState = {
  options: []
};

var ReferenceInputEnumAll =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ReferenceInputEnumAll, _Component);

  function ReferenceInputEnumAll() {
    var _this;

    (0, _classCallCheck2.default)(this, ReferenceInputEnumAll);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceInputEnumAll).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = initialState;
    _this.referenceAtom = null;
    return _this;
  }

  (0, _createClass2.default)(ReferenceInputEnumAll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.configureResolver(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.resolver !== this.props.resolver) {
        if (this.referenceAtom) {
          (0, _atom.unwatch)(this.referenceAtom, this.handleOptionsChange);
        }

        this.configureResolver(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handleOptionsChange);
      }
    }
  }, {
    key: "configureResolver",
    value: function configureResolver(props) {
      var resolver = props.resolver;
      this.referenceAtom = resolver.all();
      (0, _atom.watch)(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;
      return options.concat(this.state.options);
    }
  }, {
    key: "handleOptionsChange",
    value: function handleOptionsChange(options) {
      var _this$props = this.props,
          filter = _this$props.filter,
          optionFormatter = _this$props.optionFormatter;

      if ((0, _utils.isResolved)(options)) {
        var filteredOptions = filter ? options.filter(filter) : options;
        var formatter = typeof optionFormatter === 'function' ? optionFormatter : _ReferenceRecord.default.toOption;
        this.setState({
          options: filteredOptions.sort(function (a, b) {
            return a.getIn(['referencedObject', 'displayOrder'], -1) - b.getIn(['referencedObject', 'displayOrder'], -1);
          }).map(formatter).toArray()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var transferrableProps = (0, _omit.default)(['onCancel', 'onSecondaryChange', 'onInvalidProperty'], this.props);
      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, transferrableProps, {
        options: this.getOptions(),
        ref: "input"
      }));
    }
  }]);
  return ReferenceInputEnumAll;
}(_react.Component);

exports.default = ReferenceInputEnumAll;
ReferenceInputEnumAll.propTypes = propTypes;
ReferenceInputEnumAll.defaultProps = defaultProps;
module.exports = exports.default;